/** In-memory cache. */

class Cache {
    public keys = {
        DEFAULT_CONTENTFUL_CLIENT: 'DEFAULT_CONTENTFUL_CLIENT',
        /** Productivity methods: */
        PROD_METHODS_MAIN_PAGE_DATA: 'PROD_METHODS_MAIN_PAGE_DATA',
        PROD_METHODS_POSTS_BY_SLUG: 'PROD_METHODS_POSTS_BY_SLUG',
        /** Integrations page */
        INTEGRATIONS: 'INTEGRATIONS',
        /** Remote Work Guides */
        REMOTE_WORK_GUIDES: 'REMOTE_WORK_GUIDES',
        FEATURE_FLAGS: 'FEATURE_FLAGS',
        /** Help Center */
        HELP_CENTER: 'HELP_CENTER',
        /** Banners */
        BANNERS: 'BANNERS',
        /** /customers page */
        CUSTOMERS: 'CUSTOMERS',
        /** Contact Form */
        CONTACT_FORM: 'CONTACT_FORM',
        /** Pricing Model */
        PRICING_MODEL: 'PRICING_MODEL',
    }
    private cacheObject: Record<string, any> = {}
    private static _instance: Cache
    public static get Instance() {
        return this._instance || (this._instance = new this())
    }
    public set(key: string, val: any) {
        this.cacheObject[key] = val
    }
    public get(key: string) {
        return this.cacheObject[key]
    }
    public reset() {
        this.cacheObject = {}
    }
}

const cache = Cache.Instance

export { cache }
